export const storageTypesFormatted = {
	climateControlled: "Climate Controlled",
	"24HourAccess": "24-Hour Access",
	carStorage: "Car Storage",
	boatStorage: "Boat Storage",
	rvStorage: "RV Storage"
};
